export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10490.863b56a5.jpg";